import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { InformationOutline } from "pcln-icons";
import { useOtpContext } from "../../context/OtpContext.js";
import { Box, Flex, GenericBanner, Text } from "pcln-design-system";
const FindMyTripsErrors = ()=>{
    const { otpRequestErrorMsg } = useOtpContext();
    const messageEndRef = useRef(null);
    useEffect(()=>{
        messageEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        otpRequestErrorMsg
    ]);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            otpRequestErrorMsg ? /*#__PURE__*/ jsx(Flex, {
                flexDirection: "column",
                justifyContent: "center",
                "data-testid": "try-again",
                children: /*#__PURE__*/ jsx(GenericBanner, {
                    mx: 3,
                    my: 3,
                    p: 2,
                    borderRadius: "lg",
                    color: "background.light",
                    iconLeft: /*#__PURE__*/ jsx(InformationOutline, {
                        color: "warning.base",
                        "data-testid": "information-outline-icon"
                    }),
                    text: /*#__PURE__*/ jsxs(Text.span, {
                        textStyle: "subheading6",
                        children: [
                            otpRequestErrorMsg,
                            /*#__PURE__*/ jsx(Text.span, {
                                textStyle: "subheading6",
                                children: "Please try again."
                            })
                        ]
                    })
                })
            }) : null,
            /*#__PURE__*/ jsx(Box, {
                ref: messageEndRef
            })
        ]
    });
};
const ErrorComponent = FindMyTripsErrors;
export { ErrorComponent as default };
